import { Grid } from "@material-ui/core";
import {
  FunctionField,
  ReferenceField,
  TextField,
  useRecordContext,
} from "react-admin";
import CustomDateField from "./CustomDateField";
import CustomLabeled from "./layout/CustomLabeled";

const OwnershipField = () => {
  const record = useRecordContext();
  return (
    <>
      <Grid item xs={3}>
        <CustomLabeled name="Ownership">
          <FunctionField
            render={() =>
              record.subcontractorId === 1 ? "WTS" : "Subcontractor"
            }
          />
        </CustomLabeled>
      </Grid>
      <Grid item xs={9}></Grid>

      {record.subcontractorId !== 1 && (
        <>
          <Grid item xs={3}>
            <CustomLabeled name="Subcontractor">
              <ReferenceField
                source="subcontractorId"
                reference="subcontractors"
                emptyText="-"
                link="show"
              >
                <TextField source="name" />
              </ReferenceField>
            </CustomLabeled>
          </Grid>
          <Grid item xs={9}></Grid>
        </>
      )}

      {record.subcontractorId === 1 && (
        <>
          <Grid item xs={3}>
            <CustomLabeled name="Employee Code">
              <TextField source="employeeCode" emptyText="-" />
            </CustomLabeled>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={3}>
            <CustomLabeled name="Commencement Date">
              <CustomDateField source="commencementDate" />
            </CustomLabeled>
          </Grid>
          <Grid item xs={3}>
            <CustomLabeled name="Resignation Date">
              <CustomDateField source="resignationDate" />
            </CustomLabeled>
          </Grid>
          <Grid item xs={6}></Grid>
        </>
      )}
    </>
  );
};

export default OwnershipField;
